import { configureStore } from "@reduxjs/toolkit";

import preferenceSlice from "./slices/preferenceSlice";
import contactSlice from "./slices/contactSlice";
import invoiceSlice from "./slices/invoiceSlice";
import productSlice from "./slices/productSlice";
import mappingSlice from "./slices/mappingSlice";
import subscriptionSlice from "./slices/subscriptionSlice";

export const store = configureStore({
  reducer: {
    preference: preferenceSlice,
    contact: contactSlice,
    invoice: invoiceSlice,
    product: productSlice,
    mapping: mappingSlice,
    subscription: subscriptionSlice,
  },
});
